import * as ACTION_TYPES from "./actionTypes";
import * as GLOBAL_ACTION_TYPE from "../../globalStore/actionTypes";
export const initialState = {
    isLoading: false,
    success: false,
    successMsg: null,
    disableActions: false,
    payload: {},
    cartItems: [],
    cartId: null,
    cartStatus: 0,
    isPartialCartRefund: false,
    totalCount: 0,
    totalAmount: 0,
    totalRefundAmount: 0,
    beginTxData: {},
    reviewData: {},
    activeAction: null,
    warrantyId: null,
    errors: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.GET_CART_ITEMS: {
            return {
                ...state,
                activeAction: null,
                payload: action.data,
                cartItems: [],
                cartStatus: 0,
                isPartialCartRefund: false,
                isLoading: true,
            };
        }
        case ACTION_TYPES.GET_CART_ITEMS_SUCCESS: {
            const {
                shoppingCartLineItem,
                status,
                isPartialCartRefund,
                totalCount,
                totalRefundAmount,
                totalAmount,
            } = action.data;
            return {
                ...state,
                cartItems: shoppingCartLineItem,
                totalAmount,
                totalRefundAmount,
                cartStatus: status,
                isPartialCartRefund,
                totalCount,
                errors: null,
                isLoading: false,
            };
        }
        case ACTION_TYPES.GET_CART_ITEMS_FAILURE: {
            return {
                ...state,
                cartItems: [],
                cartStatus: 0,
                isPartialCartRefund: false,
                errors: action.errors,
                isLoading: false,
            };
        }

        case ACTION_TYPES.GET_ACTIVE_SHOPPING_CART: {
            return { ...state, errors: null, cartId: null, disableActions: false, totalCount: 0, isLoading: true };
        }
        case ACTION_TYPES.GET_ACTIVE_SHOPPING_CART_SUCCESS: {
            const { shoppingCartId, totalCount, disableActions = false } = action.data || {};
            return { ...state, errors: null, cartId: shoppingCartId, totalCount, disableActions, isLoading: false };
        }
        case ACTION_TYPES.GET_ACTIVE_SHOPPING_CART_FAILURE: {
            return { ...state, errors: action.errors, isLoading: false };
        }

        case ACTION_TYPES.CREATE_SHOPPING_CART: {
            return { ...state, success: false, successMsg: null, isLoading: true };
        }
        case ACTION_TYPES.CREATE_SHOPPING_CART_SUCCESS: {
            const { shoppingCartId } = action.data || {};
            return {
                ...state,
                cartId: shoppingCartId,
                totalCount: 1,
                success: true,
                successMsg: action.successMsg,
                isLoading: false,
            };
        }
        case ACTION_TYPES.CREATE_SHOPPING_CART_FAILURE: {
            return { ...state, errors: action.errors, isLoading: false };
        }

        case ACTION_TYPES.ADD_CART_ITEM: {
            return { ...state, success: false, successMsg: null, isLoading: true };
        }
        case ACTION_TYPES.ADD_CART_ITEM_SUCCESS: {
            const { totalCount } = action.data || {};
            return { ...state, totalCount, success: true, successMsg: action.successMsg, isLoading: false };
        }
        case ACTION_TYPES.ADD_CART_ITEM_FAILURE: {
            return { ...state, errors: action.errors, isLoading: false };
        }

        case ACTION_TYPES.DELETE_CART_ITEM: {
            return { ...state, success: false, successMsg: null, isLoading: true };
        }
        case ACTION_TYPES.DELETE_CART_ITEM_SUCCESS: {
            const { totalCount } = action.data || {};
            return { ...state, success: true, totalCount, successMsg: action.successMsg, isLoading: false };
        }
        case ACTION_TYPES.DELETE_CART_ITEM_FAILURE: {
            return { ...state, errors: action.errors, isLoading: false };
        }
        case ACTION_TYPES.RESET_SHOPPING_CART_DETAILS: {
            return { ...state, cartId: null, totalCount: 0 };
        }
        case ACTION_TYPES.BEGIN_TRANSACTION: {
            return { ...state, beginTxData: {}, errors: null, isLoading: true };
        }
        case ACTION_TYPES.BEGIN_TRANSACTION_SUCCESS: {
            return { ...state, beginTxData: action.data, isLoading: false };
        }
        case ACTION_TYPES.BEGIN_TRANSACTION_FAILURE: {
            return { ...state, errors: action.errors, isLoading: false };
        }

        case ACTION_TYPES.UPDATE_ACTIVE_ACTION: {
            const { activeAction = null, warrantyId = null } = action.data || {};
            return { ...state, activeAction, warrantyId };
        }

        case ACTION_TYPES.REVIEW_WARRANTY_DATA: {
            return { ...state, isLoading: true, reviewData: {} };
        }

        case ACTION_TYPES.REVIEW_WARRANTY_DATA_SUCCESS: {
            return { ...state, isLoading: false, reviewData: action.data };
        }

        case ACTION_TYPES.RESET_REVIEW_WARRANTY_DATA: {
            return { ...state, isLoading: false, reviewData: {} };
        }
        case GLOBAL_ACTION_TYPE.CLEAR_GLOBAL_SUCCESSMSG:
        case ACTION_TYPES.CLEAR_MSG: {
            return { ...state, success: false, successMsg: null };
        }

        case ACTION_TYPES.RE_SUBMIT_CART: {
            return { ...state, beginTxData: {}, errors: null, isLoading: true };
        }
        case ACTION_TYPES.RE_SUBMIT_CART_SUCCESS: {
            return { ...state, beginTxData: action.data, isLoading: false };
        }
        case ACTION_TYPES.RE_SUBMIT_CART_FAILURE: {
            return { ...state, errors: action.errors, isLoading: false };
        }

        default:
            return state;
    }
};

export default reducer;
